import React from 'react';
import * as PropTypes from 'prop-types';
import {Dropdown, Menu} from 'antd';
import {CaretDownOutlined} from '@ant-design/icons';
import styled from 'styled-components';
import {ChartTypes} from "../ChartRender/chartLib";
// import {AreaChartOutlined} from "@material-ui/core";

const StyledDropdownTrigger = styled.span`
  color: #43436B;
  cursor: pointer;
  margin-left: 13px;

  & > span {
    margin: 0 8px;
  }
`

const SelectChartType = ({ chartType, updateChartType }) => {
  const menu = (
    <Menu>
      {ChartTypes.map(m => (
        <Menu.Item key={m.title} onClick={() => updateChartType(m.name)}>
          {m.icon()}
          {m.title}
        </Menu.Item>
      ))}
    </Menu>
  );

  const foundChartType = ChartTypes.find(t => t.name === chartType);
  return (
    <Dropdown overlay={menu} icon={foundChartType.icon} lacement="bottomLeft" trigger={['click']}>
    <StyledDropdownTrigger>
      {foundChartType.icon()}
      <span>{foundChartType.title}</span>
      <CaretDownOutlined />
    </StyledDropdownTrigger>
    </Dropdown>
  );
};

SelectChartType.propTypes = {
  chartType: PropTypes.string.isRequired,
  updateChartType: PropTypes.func.isRequired
};

export default SelectChartType;
